import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

class Warning extends PureComponent {
    static propTypes = {
        contextCls: PropTypes.string,
    };

    render() {
        const { contextCls } = this.props;

        return (
            <svg
                className={cx(this.baseCls, contextCls)}
                width="71"
                height="64"
                viewBox="0 0 71 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_178_28555)">
                    <path
                        d="M38.23 2.54596L69.7554 58.9279C70.8467 60.9892 69.3917 63.4142 67.0879 63.4142H4.0371C1.73332 63.4142 0.2783 60.8679 1.36956 58.9279L32.895 2.54596C34.1075 0.484681 37.0175 0.484681 38.23 2.54596Z"
                        fill="#9C1A97"
                        stroke="black"
                        strokeWidth="1.5"
                    />
                    <path
                        d="M35.4413 18.9213C36.6784 18.9213 37.6681 19.9109 37.6681 21.148V42.9206C37.6681 44.1576 36.6784 45.1473 35.4413 45.1473C34.2043 45.1473 33.2146 44.1576 33.2146 42.9206V21.148C33.3383 19.9109 34.328 18.9213 35.4413 18.9213Z"
                        fill="white"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M35.4408 50.4667C36.6779 50.4667 37.6676 51.4563 37.6676 52.6934C37.6676 53.9305 36.6779 54.9202 35.4408 54.9202C34.2038 54.9202 33.2141 53.9305 33.2141 52.6934C33.3378 51.4563 34.3275 50.4667 35.4408 50.4667Z"
                        fill="white"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_178_28555">
                        <rect width="71" height="64" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }

    baseCls = 'card-mgmt-svg-warning';
}

export default Warning;
